import { Button } from "@narmi/design_system";
import { Link, RouteObject, useNavigate, useParams } from "react-router-dom";
import { useUserConfiguration } from "../../hooks/useUserConfiguration";
import { TopBarPageContainer } from "../../components/PageContainer";
import { PermissionedRoutes } from "@components/PermissionedRoutes";

export const OAUTH_APP_ROUTES: RouteObject[] = [
  {
    index: true,
    async lazy() {
      const { ListPageContent } = await import("./OauthAppList");
      return {
        Component() {
          const { permissions } = useUserConfiguration();

          const getActionButton = () => {
            if (permissions.includes("public_api.create_oauth_applications")) {
              return (
                <Link to="/oauth_apps/create">
                  <Button size="xs" label="Register new app" />
                </Link>
              );
            } else {
              return null;
            }
          };

          return (
            <TopBarPageContainer title="OAuth Applications" action={getActionButton()}>
              <ListPageContent />
            </TopBarPageContainer>
          );
        },
      };
    },
  },
  {
    path: "create",
    element: <PermissionedRoutes requiredPermissions={["public_api.create_oauth_applications"]} />,
    children: [
      {
        index: true,
        async lazy() {
          const { OauthAppForm } = await import("./OauthAppForm");
          return {
            Component() {
              const navigate = useNavigate();

              return (
                <TopBarPageContainer
                  title="Register an OAuth Application"
                  backIconOnClick={() => navigate("/oauth_apps")}
                >
                  <OauthAppForm />
                </TopBarPageContainer>
              );
            },
          };
        },
      },
    ],
  },
  {
    path: ":oauthAppId/tokens",
    async lazy() {
      const { TokensListPageContent } = await import("./OauthAppTokensList");
      return {
        Component() {
          const navigate = useNavigate();
          const { oauthAppId } = useParams();

          return (
            <TopBarPageContainer
              title="OAuth Application Authorized Tokens"
              backIconOnClick={() => navigate("/oauth_apps")}
            >
              <TokensListPageContent oauthAppId={oauthAppId!} />
            </TopBarPageContainer>
          );
        },
      };
    },
  },
  {
    path: ":oauthAppId",
    element: <PermissionedRoutes requiredPermissions={["public_api.edit_oauth_applications"]} />,
    children: [
      {
        index: true,
        async lazy() {
          const { EditPageContent } = await import("./OauthAppEdit");
          return {
            Component() {
              const navigate = useNavigate();
              const { oauthAppId } = useParams();

              return (
                <TopBarPageContainer
                  title="Edit an OAuth Application"
                  backIconOnClick={() => navigate("/oauth_apps")}
                >
                  <EditPageContent appId={oauthAppId!} />
                </TopBarPageContainer>
              );
            },
          };
        },
      },
    ],
  },
];
